const initialState = {
    type: "",
    msg: "",
    subMsg: "",
    isConfirm: false,
    onClickConfirm: {},
};

const OPEN_MODAL = "OPEN_MODAL";
const CLOSE_MODAL = "CLOSE_MODAL";

export const openModal = (modalInfo) => ({ type: OPEN_MODAL, modalInfo });
export const closeModal = () => ({ type: CLOSE_MODAL });

export default function modalReducer(state = initialState, action) {
    switch (action.type) {
        case OPEN_MODAL:
            return {
                ...state,
                type: action.modalInfo.type,
                msg: action.modalInfo.msg,
                subMsg: action.modalInfo.subMsg,
                isConfirm: action.modalInfo.isConfirm,
                onClickConfirm: action.modalInfo.onClickConfirm,
            };
        case CLOSE_MODAL:
            return {
                ...state,
                type: "",
                msg: "",
                subMsg: "",
                isConfirm: false,
                onClickConfirm: {},
            };
        default:
            return state;
    }
}
